// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as PromotionEditForm from "./PromotionEditForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PromotionEditPriceNameSelect from "./PromotionEditPriceNameSelect.res.js";

let make = React.memo(props => {
  let match = PromotionEditForm.useFormState();
  let validation = match.validation;
  let dispatch = PromotionEditForm.useFormDispatch();
  let priceNameError;
  priceNameError = validation.TAG === "Ok" ? undefined : Stdlib_Array.filterMap(validation._0, param => {
        if (param[0]._0 === "PriceName") {
          return param[1];
        }
      })[0];
  let onChange = React.useCallback(value => dispatch({
    TAG: "FieldValueChanged",
    _0: "PriceName",
    _1: param => {
      if (value !== "") {
        return value;
      }
    }
  }), []);
  let errorMessage;
  if (priceNameError !== undefined) {
    let tmp = match.submission;
    errorMessage = typeof tmp !== "object" || tmp.TAG !== "Failed" ? undefined : I18n.t(priceNameError);
  } else {
    errorMessage = undefined;
  }
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(PromotionEditPriceNameSelect.make, {
        required: true,
        errorMessage: errorMessage,
        value: Stdlib_Option.getOr(match.values.priceName, ""),
        onChange: onChange
      }),
      JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Warning",
            _0: I18n.t("Beware ! Once the draft is saved, you will no longer be able to edit the price list.")
          },
          compact: false
        }),
        spaceTop: "small"
      })
    ],
    space: "xsmall"
  });
});

let PromotionEditPriceNameFormSelect = {
  make: make
};

function PromotionEditFormInformationCard(props) {
  let editable = props.editable;
  let match = PromotionEditForm.useFormState().values;
  let period = match.period;
  let priceName = match.priceName;
  return JsxRuntime.jsxs(Card.make, {
    children: [
      editable ? (
          props.promotionCreated ? (
              priceName !== undefined ? JsxRuntime.jsxs(Stack.make, {
                  children: [
                    JsxRuntime.jsx(PromotionEditForm.InputText.make, {
                      field: "Name",
                      label: I18n.t("Name of the campaign"),
                      placeholder: I18n.t("Wine fair 2020")
                    }),
                    JsxRuntime.jsx(Box.make, {
                      spaceBottom: "normal"
                    }),
                    JsxRuntime.jsxs(InlineText.make, {
                      children: [
                        JsxRuntime.jsx(TextStyle.make, {
                          children: I18n.t("Price list") + " ",
                          variation: "normal"
                        }),
                        JsxRuntime.jsx(TextStyle.make, {
                          children: priceName
                        })
                      ]
                    })
                  ],
                  space: "xxsmall"
                }) : null
            ) : JsxRuntime.jsxs(Stack.make, {
              children: [
                JsxRuntime.jsx(PromotionEditForm.InputText.make, {
                  field: "Name",
                  label: I18n.t("Name of the campaign"),
                  placeholder: I18n.t("Wine fair 2020")
                }),
                JsxRuntime.jsx(make, {})
              ],
              space: "large"
            })
        ) : (
          priceName !== undefined ? JsxRuntime.jsxs(Stack.make, {
              children: [
                JsxRuntime.jsxs(InlineText.make, {
                  children: [
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.t("Campaign") + " ",
                      variation: "normal"
                    }),
                    JsxRuntime.jsx(TextStyle.make, {
                      children: match.name,
                      weight: "semibold"
                    })
                  ]
                }),
                JsxRuntime.jsxs(InlineText.make, {
                  children: [
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.t("Price list") + " ",
                      variation: "normal"
                    }),
                    JsxRuntime.jsx(TextStyle.make, {
                      children: priceName
                    })
                  ]
                })
              ],
              space: "xxsmall"
            }) : null
        ),
      JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal",
        spacing: "xs"
      }),
      editable ? JsxRuntime.jsx(PromotionEditForm.InputDateRange.make, {
          label: I18n.t("Dates of the campaign"),
          placeholder: I18n.t("Select a period"),
          field: "Period"
        }) : (
          period !== undefined ? JsxRuntime.jsxs(Stack.make, {
              children: [
                JsxRuntime.jsxs(InlineText.make, {
                  children: [
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.t("Start of the campaign at the") + " ",
                      variation: "normal"
                    }),
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, period[0])
                    })
                  ]
                }),
                JsxRuntime.jsxs(InlineText.make, {
                  children: [
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.t("End of the campaign at the") + " ",
                      variation: "normal"
                    }),
                    JsxRuntime.jsx(TextStyle.make, {
                      children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, period[1])
                    })
                  ]
                })
              ],
              space: "xxsmall"
            }) : null
        )
    ],
    title: I18n.t("Information"),
    variation: "common",
    grow: true
  });
}

let make$1 = React.memo(PromotionEditFormInformationCard);

export {
  PromotionEditPriceNameFormSelect,
  make$1 as make,
}
/* make Not a pure module */
